import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PersonalData, SituationData, } from '../../../../../assets/js/com/ts_api_client';
import { LoginService } from '../../../../login/login.service';
import { HomeData } from '../../../models/home';
import { ALLOWED_KEYS, StorageService } from '../../../services/storage.service';
import { ReBaseData } from '../../../../shared/utils/re-base-data';
import { MoveService } from '../../../services/move.service';
import { AvailableDivisionInfos } from '../new-home/product-selection/product-selection.component';
import { TrackingService } from '../../../services/tracking.service';
import { TRACKING } from '../../../enums/trackingParts.enum';
import { ExternalTenantConfiguration } from './external-tenant-tile/external-tenant-tile.component';
import { Utilities } from '../../../../shared/utils/utilities';
import { LocationStrategy } from '@angular/common';
import { TrustpilotService } from '../../../services/trustpilot.service';
import { TariffAdvisorService } from '../../../services/tariff-advisor.service';


@Component({
    selector: 'bdo-move-confirmation',
    templateUrl: './move-confirmation.component.html',
    styleUrls: ['./move-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoveConfirmationComponent implements OnInit, AfterViewInit {
  public email: string;
  public cancelDate: Date;
  public startDate: Date;
  public trustpilotUniqueUrl: string;
  public divisionsForInfo: string = '';
  public availableDivisionInfos: AvailableDivisionInfos;
  public isRegistered: boolean;
  public externalTenantConfigurations: ExternalTenantConfiguration[];
  public postCode: string;
  public TRACKING = TRACKING;
  public productIds: Array<string>;
  protected reBaseData = ReBaseData;

  constructor (
    public moveService: MoveService,
    public loginService: LoginService,
    public tariffService: TariffAdvisorService,
    private trackingService: TrackingService,
    private locationStrategy: LocationStrategy,
    private trustpilotService: TrustpilotService
  ) { }

  ngAfterViewInit(): void {
    // Cleanup all sessionData but not before the view has been init (there are dependencies on the storage)
    window.sessionStorage.clear();
    Utilities.disableBrowsersBackButton(this.locationStrategy);
  }

  ngOnInit(): void {
    this.trackingService.postTracking(TRACKING.LOCATION.MOVE_CONFIRMATION, TRACKING.ACTION.ENTER);

    this.divisionsForInfo = this.moveService.divisionsForInfo();
    this.isRegistered = this.moveService.isAnonymousButRegistered();
    this.availableDivisionInfos = StorageService.getValue<AvailableDivisionInfos>(ALLOWED_KEYS.AVAILABLE_DIVISIONS);
    this.postCode = StorageService.getPersonalData()?.addressData?.postCode;
    this.trustpilotUniqueUrl = this.trustpilotService.buildTrustpilotUniqueUrl(StorageService.getTrustPilotToken());
    this.email = StorageService.getValue<PersonalData>(ALLOWED_KEYS.PERSONAL_DATA)?.email;
    this.startDate = StorageService.getValue<SituationData>(ALLOWED_KEYS.SITUATION_DATA)?.startDate ?
                    new Date(StorageService.getValue<SituationData>(ALLOWED_KEYS.SITUATION_DATA)?.startDate) :
                    null;
    this.cancelDate = StorageService.getValue<HomeData>(ALLOWED_KEYS.RECENT_HOME_DATA)?.date ?
                     new Date(StorageService.getValue<HomeData>(ALLOWED_KEYS.RECENT_HOME_DATA)?.date) :
                     null;

    this.productIds = StorageService.getTariffData()?.map(tariff => tariff.productId);
  }

}
